module.exports = __webpack_public_path__ + "img/Categories_bg_005.18b6c447.jpg";